import { Lottie } from '@web_opxp/lottie';
import findLast from 'lodash/findLast';
import * as React from 'react';
import { connect } from 'react-redux';
import { CyclesSelectors } from '../../cycles';
import { IState } from '../../store/state';
import UserLevel from '../userLevel/UserLevel';
import './BrainLevel.scss';
import LevelLotties from './levelLotties.json';
const LottieAnimation = Lottie.Component.default;

export interface IBrainLevelProps {
  className?: string;
  level: number;
  cycleLength: number;
  sessionId: number;
}

export const BrainLevelFC: React.FC<IBrainLevelProps> = ({ className = '', level, cycleLength, sessionId }) => {
  const currentLevel = findLast(LevelLotties, (lottie) => lottie.minLevel <= level);
  if (!currentLevel) {
    throw new Error('current brain level is not defined');
  }
  const brainLevelAnimation = currentLevel.lottie;
  const [divHeight, setDivHeight] = React.useState(0);
  const divRef = React.useRef<HTMLDivElement>(null);

  const handleResize = React.useCallback(
    (entries: ResizeObserverEntry[]) => {
      if (!Array.isArray(entries)) {
        return;
      }
      const entry = entries[0];
      const height = entry.contentRect.height;
      setDivHeight(height);
    },
    [setDivHeight]
  );

  React.useLayoutEffect(() => {
    if (!divRef.current) {
      return;
    }
    const { height } = divRef.current.getBoundingClientRect();
    setDivHeight(height);

    let RO: ResizeObserver | null = new ResizeObserver(handleResize);
    RO.observe(divRef.current);
    return () => {
      if (!RO) {
        return;
      }
      RO.disconnect();
      RO = null;
    };
  }, [handleResize]);

  return (
    <div
      className={`brain-level ${className}`}
      ref={divRef}
      style={{ '--height': `${divHeight}px` } as React.CSSProperties}>
      <div className="img-wrapper">
        <LottieAnimation name={brainLevelAnimation} autoplay={true} loop={false} />
        <UserLevel level={level} session={sessionId} cycleLength={cycleLength} />
      </div>
    </div>
  );
};

export const mapStateToProps = (state: IState) => {
  const cycleLength = CyclesSelectors.getCycleLength(state);
  const sessionId = CyclesSelectors.getCurrentSessionId(state);
  const level = CyclesSelectors.getCurrentCycleId(state);
  return {
    level,
    cycleLength,
    sessionId,
  };
};

const BrainLevel = connect(mapStateToProps)(BrainLevelFC);

export default BrainLevel;
